"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionGroup = void 0;
const internal_1 = require("../../internal");
/**
 * Represents a group of permissions for an Asset
 */
class PermissionGroup extends internal_1.Entity {
    /**
     * @hidden
     */
    constructor(identifiers, context) {
        super(identifiers, context);
        const { assetId } = identifiers;
        this.asset = new internal_1.FungibleAsset({ assetId }, context);
    }
}
exports.PermissionGroup = PermissionGroup;
//# sourceMappingURL=PermissionGroup.js.map